// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3Q4Kh","col":"CardReaderDesc_col__1pw3w","label":"CardReaderDesc_label__1bSLu"};